// extracted by mini-css-extract-plugin
export var closeButton = "_e-1";
export var container = "_e-0";
export var fullModalImage = "_e-2";